import { render } from "./BlockChain.vue?vue&type=template&id=58052446&scoped=true"
import script from "./BlockChain.vue?vue&type=script&lang=js"
export * from "./BlockChain.vue?vue&type=script&lang=js"

import "./BlockChain.vue?vue&type=style&index=0&id=58052446&lang=less&scoped=true"
import "./BlockChain.vue?vue&type=style&index=1&id=58052446&lang=less"

import exportComponent from "/home/data/jenkins/workspace/Pro_TWI_T/Pro_TWI_h5_advantrade-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58052446"]])

export default __exports__